import { render, staticRenderFns } from "./VerifyCompany.vue?vue&type=template&id=291e889a"
import script from "./VerifyCompany.vue?vue&type=script&lang=js"
export * from "./VerifyCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports